import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { CustomDropdown } from 'src/components';
import { useCurrentUser } from 'src/hooks';
import DArrowSvg from '../../images/icons/darrow-blank.svg?react';

export const SolutionsDropdown = () => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) setAnchorEl(e.currentTarget);
    setOpen((prev) => !prev);
  };

  const id = open ? 'solutions-dropdown' : undefined;

  return (
    <>
      <button
        aria-expanded={open}
        onClick={handleClick}
        className={`${user ? 'hidden lg:flex' : 'hidden md:flex'} items-center gap-2 font-secondary text-base font-semibold text-skyBlue transition-all hover:text-white`}
      >
        {t('navbar.solutions')}
        <DArrowSvg
          style={{
            transform: open ? 'rotate(-180deg)' : 'rotate(0deg)',
            transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1)',
          }}
          width='20'
          height='20'
        />
      </button>
      <CustomDropdown id={id} open={open} anchorEl={anchorEl} handleClick={() => setOpen(false)}>
        <div className='mt-2 flex w-full flex-col items-start gap-2 rounded-lg border border-gray-300 bg-cloudGray px-5 py-5 font-secondary text-base font-semibold'>
          <NavLink
            to='/solutions/consumers'
            reloadDocument
            onClick={() => setOpen(false)}
            className='inline-flex w-full items-center gap-2 rounded-md px-1 py-0.5 text-primary hover:bg-gray-300/60 hover:text-primary-hover'
          >
            {t('solutions.for_consumers')}
          </NavLink>
          <NavLink
            to='/solutions/schools'
            reloadDocument
            onClick={() => setOpen(false)}
            className='inline-flex w-full items-center gap-2 rounded-md px-1 py-0.5 text-primary hover:bg-gray-300/60 hover:text-primary-hover'
          >
            {t('solutions.for_schools')}
          </NavLink>
          <NavLink
            to='/solutions/businesses'
            reloadDocument
            onClick={() => setOpen(false)}
            className='inline-flex w-full items-center gap-2 rounded-md px-1 py-0.5 text-primary hover:bg-gray-300/60 hover:text-primary-hover'
          >
            {t('solutions.for_businesses')}
          </NavLink>
        </div>
      </CustomDropdown>
    </>
  );
};
